import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router';
import { useNavigationPaths } from '../../propertyAssociation/useNavigationPaths';
import { BookingTypes } from '../BookingTypes';

type Props = {
    setBookingType: (bookingType: BookingTypes) => void;
}

const SelectBookingType: FunctionComponent<Props> = ({setBookingType}) => {
    const paths = useNavigationPaths();
    const navigate = useNavigate();
    
    return (
        <div className="app__inner app__inner--center">
            <div className="text-center">
                <h1 className="large-heading">Vilken typ av bokning vill du göra?</h1>
                <p className="preamble">I nästa steg väljer du tid och datum för bokning.</p>
            </div>
            <div>
                <div className="boxlist">
                    <button className="boxlist__item boxlist__item--no-image" onClick={() => setBookingType(BookingTypes.Internal)}>Intern bokning</button>
                    <button className="boxlist__item boxlist__item--no-image" onClick={() => setBookingType(BookingTypes.Intermediate)}>Förmedlingsbokning</button>
                </div>
                <div className="mt-5 text-center">
                    <button className="btn btn-lg btn-secondary btn-next" onClick={() => navigate(paths.newBooking)}>Avbryt</button>
                </div>
            </div>
        </div>
    )
}

export default SelectBookingType